import styled from 'styled-components';

export const PreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const FileInfo = styled.div`
  text-align: center;

  .file-name {
    font-weight: bold;
    margin-bottom: 8px;
  }

  .file-details {
    color: rgba(0, 0, 0, 0.45);
  }
`;




